"use client";

import React, {useState} from "react";
import {Button, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuLabel} from "../../";

export interface FilterDropdownProps {
  selectedAssetType?: string | null;
  onChange?: (payload: {
    type: "assetType" | "reset";
    value: any
  }) => void;
}

const FilterDropdown = React.forwardRef<Element, FilterDropdownProps>(
  ({
    selectedAssetType = "book",
    onChange,
  }
) => {
    const [isOpen, setIsOpen] = useState(false);

    const assetTypes = [
      {
        key: "book",
        label: "Books",
        icon: "fa-books"
      },
      {
        key: "document",
        label: "Documents",
        icon: "fa-file-doc"
      },
      {
        key: "article",
        label: "Articles",
        icon: "fa-file"
      },
      {
        key: "presentation",
        label: "Presentations",
        icon: "fa-presentation-screen"
      },
      {
        key: "video",
        label: "Videos",
        icon: "fa-circle-play"
      }
    ];

    const activeAssetTypeObj = assetTypes.find(a => a.key === selectedAssetType) ?? {
      key: "book",
      label: "Books",
      icon: "fa-books"
    };

    return (
      <DropdownMenu
        onOpenChange={setIsOpen}>
        <DropdownMenuTrigger
          asChild>
          <Button
            variant="vanilla"
            className="h-8 px-2 gap-2 flex items-center border-none bg-bluegray-darker text-sm text-white rounded-[25px] cursor-pointer transition-colors duration-200"
          >
            <i className={`fa-duotone fa-light ${activeAssetTypeObj.icon} text-sm text-bluegray-lighter`}/>
            <span className="text-xs text-left font-medium text-white">{activeAssetTypeObj.label}</span>
            <i className={`fa-duotone fa-light fa-chevron-${isOpen ? 'up' : 'down'} text-[10px] text-bluegray-lighter transition-transform duration-200`}/>
          </Button>
        </DropdownMenuTrigger>

        <DropdownMenuContent
          className="w-34 bg-bluegray-darker rounded-[6px] shadow-[1px_1px_2px_1px_rgba(105,120,127,1)]!"
        >
          <DropdownMenuLabel className="bg-bluegray-medium/50 text-bluegray-lighter font-extrabold text-[11px] tracking-wider px-2 py-1">Filter By</DropdownMenuLabel>
          {assetTypes.map((type) => {
            const isSelected = selectedAssetType === type.key;
            return (
              <DropdownMenuItem
                key={type.key}
                onClick={() => onChange?.({
                  type: "assetType",
                  value: type.key
                })}
                className={`flex items-center justify-between text-xs transition duration-200 cursor-pointer px-2 py-1.5 ${
                  isSelected 
                    ? 'text-white bg-bluegray-light/30' 
                    : 'text-bluegray-lighter hover:text-generic-hover hover:bg-bluegray-light/12'
                }`}
              >
                <div
                  className="flex items-center gap-2">
                  <i
                    className={`fa-duotone fa-light ${type.icon} text-sm w-4 text-center text-bluegray-lighter`}/>
                  <span>{type.label}</span>
                </div>
                {isSelected &&
                  <i
                    className="fa-duotone fa-light fa-check text-[10px] text-bluegray-lighter"/>}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }
);

FilterDropdown.displayName = "FilterDropdown";
export {FilterDropdown};